export const setProfile = (profile : any) => (
	{
		type: 'SET_PROFILE',
		payload: profile,
	}
);
